import { logout } from 'services/AuthService'

type Props = {
  baseUrl?: string
}

export const Logout = ({ baseUrl = '' }: Props) => {
  logout()
  window.location.href = `/${baseUrl}`
  return <></>
}
